export default class Header {
    body;
    header;
    hero;
    main;
    constructor(resizeService) {
        this.body = document.querySelector('body');
        this.header = this.body.querySelector('.js-header');
        this.hero = this.body.querySelector('.js-hero');
        this.main = this.body.querySelector('.js-main');
        if (this.hero) {
            this.header.classList.add('header--white');
        }
        else {
            resizeService.watch().subscribe((event) => this.mainSpacer());
            this.mainSpacer();
        }
    }
    mainSpacer() {
        Object.assign(this.main.style, {
            paddingTop: `${this.header.offsetHeight}px`,
        });
    }
}
